import CommonDDService from "../../services/CommonDDService";
import CommonService from "../../services/CommonService";
import NodeLockPannelService from "../../services/NodeLockPannelService";
import DropdownService from "../../services/DropdownService";
import RemarkService from "../../services/RemarkService";
export default {
  namespaced: true,
  state: {
    allLocDDList: [],
    allPendingSlineInvDDList: [],
    allENQDDList: [],
    allENQTERIOTRYDDList: [],
    allAgentDDList: [],
    allPortExpenseDDList: [],
    allPickupDDList: [],
    allHandoverDDList: [],
    allStuffingDDList: [],
    allSlineAccDDList: [],

    allTallyVendorDDList: [],
    allTallyVendorGSTDDList: [],

    allVehicleDDList: [],
    allDriverDDList: [],

    allExpenseHeadDDList: [],
    allExpenseParticularDDList: [],
    allInvoiceHeadDDList: [],
    allInvoiceParticularDDList: [],
  },
  getters: {
    getAllLocDDList: (state) => state.allLocDDList,
    getAllPendingSlineInvDDList: (state) => state.allPendingSlineInvDDList,
    getAllENQDDList: (state) => state.allENQDDList,
    getAllENQTERIOTRYDDList: (state) => state.allENQTERIOTRYDDList,
    getAllAgentDDList: (state) => state.allAgentDDList,
    getAllPortExpenseDDList: (state) => state.allPortExpenseDDList,
    getAllPickupList: (state) => state.allPickupDDList,
    getAllHandoverList: (state) => state.allHandoverDDList,
    getAllStuffingList: (state) => state.allStuffingDDList,
    getAllSlineAccList: (state) => state.allSlineAccDDList,

    getAllTallyVendorList: (state) => state.allTallyVendorDDList,
    getAllTallyVendorGstList: (state) => state.allTallyVendorGSTDDList,

    getAllVehicleDDList: (state) => state.allVehicleDDList,
    getAllDriverDDList: (state) => state.allDriverDDList,

    getAllExpenseHeadDDList: (state) => state.allExpenseHeadDDList,
    getAllExpenseParticularDDList: (state) => state.allExpenseParticularDDList,
    getAllInvoiceHeadDDList: (state) => state.allInvoiceHeadDDList,
    getAllInvoiceParticularDDList: (state) => state.allInvoiceParticularDDList,
    getAllRemarkDDList: (state) => state.allRemarkDDList,
  },

  mutations: {
    SET_ALL_PENDING_SLINE_INV_DD_LIST(state, val) {
      state.allPendingSlineInvDDList = val;
    },
    SET_ALL_LOC_DD_LIST(state, val) {
      state.allLocDDList = val;
    },
    SET_ALL_ENQ_DD_LIST(state, val) {
      state.allENQDDList = val;
    },
    SET_ALL_ENQ_TERIOTRY_DD_LIST(state, val) {
      state.allENQTERIOTRYDDList = val;
    },
    SET_ALL_Agent_DD_LIST(state, val) {
      state.allAgentDDList = val;
    },
    SET_ALL_PORT_EXPENSE_DD_LIST(state, val) {
      state.allPortExpenseDDList = val;
    },
    SET_ALL_PICKUP_DD_LIST(state, val) {
      state.allPickupDDList = val;
    },
    SET_ALL_HANDOVER_DD_LIST(state, val) {
      state.allHandoverDDList = val;
    },
    SET_ALL_STUFFING_DD_LIST(state, val) {
      state.allStuffingDDList = val;
    },

    SET_ALL_SLINE_ACC_DD_LIST(state, val) {
      state.allSlineAccDDList = val;
    },
    SET_ALL_TALLY_VENDOR_DD_LIST(state, val) {
      state.allTallyVendorDDList = val;
    },
    SET_ALL_TALLY_VENDOR_GST_DD_LIST(state, val) {
      state.allTallyVendorGSTDDList = val;
    },

    SET_ALL_VEHICLE_DD_LIST(state, val) {
      state.allVehicleDDList = val;
    },

    SET_ALL_DRIVER_DD_LIST(state, val) {
      state.allDriverDDList = val;
    },

    SET_ALL_INV_HEAD_DD_LIST(state, val) {
      state.allInvoiceHeadDDList = val;
    },
    SET_ALL_INV_PARTICULAR_DD_LIST(state, val) {
      state.allInvoiceParticularDDList = val;
    },
    SET_ALL_EXP_HEAD_DD_LIST(state, val) {
      state.allExpenseHeadDDList = val;
    },
    SET_ALL_EXP_PARTICULAR_DD_LIST(state, val) {
      state.allExpenseParticularDDList = val;
    },
  },
  actions: {
    setAllPendingSlineInvDDList: async (
      { dispatch, commit, state },
      payload,
    ) => {
      await commit("SET_ALL_PENDING_SLINE_INV_DD_LIST", []);
      DropdownService.getAllPendingSlineInv(payload)
        .then(async (response) => {
          if (response.status == 200 && response.data && response.data.data) {
            await commit(
              "SET_ALL_PENDING_SLINE_INV_DD_LIST",
              response.data.data,
            );
          } else {
          }
        })
        .catch((err) => {
          console.log("Error in getting getAllPendingSlineInvDDList ", err);
        });
    },
    setAllLocDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_LOC_DD_LIST", []);
      DropdownService.getAllLocation(payload)
        .then(async (response) => {
          if (response.status == 200 && response.data && response.data.data) {
            await commit("SET_ALL_LOC_DD_LIST", response.data.data);
          } else {
          }
        })
        .catch((err) => {
          console.log("Error in getting getAllLocDDList ", err);
        });
    },
    setAllENQDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_DD_LIST", []);
      CommonDDService.getAllENQDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.ENQList
          ) {
            await commit("SET_ALL_ENQ_DD_LIST", response.data.ENQList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllENQDDList ", err);
        });
    },
    setAllENQTERIOTRYDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_ENQ_TERIOTRY_DD_LIST", []);
      CommonService.getAllJobList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getAllENQTERIOTRYDDList
          ) {
            await commit(
              "SET_ALL_ENQ_TERIOTRY_DD_LIST",
              response.data.getAllENQTERIOTRYDDList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getAllDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllENQTERIOTRYDDList ", err);
        });
    },
    setAllAgentDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_Agent_DD_LIST", []);
      CommonService.getAllJobList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getAgentDDList
          ) {
            await commit("SET_ALL_Agent_DD_LIST", response.data.getAgentDDList);
          } else {
            // console.log(response.data);
          }
          // console.log("getAllDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllAgentDDList ", err);
        });
    },
    setAllPortExpenseDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_PORT_EXPENSE_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.All_Document_Type_List_data
          ) {
            await commit(
              "SET_ALL_PORT_EXPENSE_DD_LIST",
              response.data.All_Document_Type_List_data,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("getAllDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllPortExpenseDDList ", err);
        });
    },
    setAllPickupDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_PICKUP_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.AllPickupList
          ) {
            await commit("SET_ALL_PICKUP_DD_LIST", response.data.AllPickupList);
          } else {
            // console.log(response.data);
          }
          // console.log("AllPickupList", response);
        })
        .catch((err) => {
          console.log("Error in getting AllPickupList ", err);
        });
    },
    setAllHandoverDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_HANDOVER_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.AllHandoverList
          ) {
            await commit(
              "SET_ALL_HANDOVER_DD_LIST",
              response.data.AllHandoverList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("AllHandoverList", response);
        })
        .catch((err) => {
          console.log("Error in getting AllHandoverList ", err);
        });
    },
    setAllStuffingDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_STUFFING_DD_LIST", []);
      CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.AllStuffingList
          ) {
            await commit(
              "SET_ALL_STUFFING_DD_LIST",
              response.data.AllStuffingList,
            );
          } else {
            // console.log(response.data);
          }
          // console.log("AllStuffingList", response);
        })
        .catch((err) => {
          console.log("Error in getting AllStuffingList ", err);
        });
    },

    setAllTallyVendorDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_TALLY_VENDOR_DD_LIST", []);
      CommonDDService.getAllExpenseDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.MasterVendorList
          ) {
            await commit(
              "SET_ALL_TALLY_VENDOR_DD_LIST",
              response.data.MasterVendorList,
            );
          } else {
            // console.log(response.data);
          }
        })
        .catch((err) => {
          console.log("Error in getting MasterVendorList ", err);
        });
    },

    setAllTallyVendorGstDDList: async (
      { dispatch, commit, state },
      payload,
    ) => {
      await commit("SET_ALL_TALLY_VENDOR_GST_DD_LIST", []);
      await CommonDDService.getAllExpenseDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.MasterVendorList
          ) {
            await commit(
              "SET_ALL_TALLY_VENDOR_GST_DD_LIST",
              response.data.MasterVendorList,
            );
          } else {
            // console.log(response.data);
          }
        })
        .catch((err) => {
          console.log("Error in getting MasterVendorGSTList ", err);
        });
    },

    setAllVehicleDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_VEHICLE_DD_LIST", []);
      await CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getVehicleList
          ) {
            await commit(
              "SET_ALL_VEHICLE_DD_LIST",
              response.data.getVehicleList,
            );
          } else {
            // console.log(response.data);
          }
        })
        .catch((err) => {
          console.log("Error in getting getVehicleList ", err);
        });
    },

    setAllDriverDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_DRIVER_DD_LIST", []);
      await CommonDDService.getAllDDList(payload)
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.getDriverList
          ) {
            await commit("SET_ALL_DRIVER_DD_LIST", response.data.getDriverList);
          } else {
            // console.log(response.data);
          }
        })
        .catch((err) => {
          console.log("Error in getting getAllDriverDDList ", err);
        });
    },
    setAllInvHeadDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_INV_HEAD_DD_LIST", []);
      await NodeLockPannelService.invoiceHead(payload)
        .then(async (response) => {
          if (response.status == 200 && response.data && response.data.data) {
            await commit("SET_ALL_INV_HEAD_DD_LIST", response.data.data);
          } else {
            // console.log(response.data);
          }
        })
        .catch((err) => {
          console.log("Error in getting invoiceHead ", err);
        });
    },
    setAllInvParticularDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_INV_PARTICULAR_DD_LIST", []);
      await NodeLockPannelService.invoiceHeadItem(payload)
        .then(async (response) => {
          if (response.status == 200 && response.data && response.data.data) {
            await commit("SET_ALL_INV_PARTICULAR_DD_LIST", response.data.data);
          } else {
            // console.log(response.data);
          }
        })
        .catch((err) => {
          console.log("Error in getting invoiceHeadItem ", err);
        });
    },
    setAllExpHeadDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_EXP_HEAD_DD_LIST", []);
      await NodeLockPannelService.expenseHead(payload)
        .then(async (response) => {
          if (response.status == 200 && response.data && response.data.data) {
            await commit("SET_ALL_EXP_HEAD_DD_LIST", response.data.data);
          } else {
            // console.log(response.data);
          }
        })
        .catch((err) => {
          console.log("Error in getting expenseHead ", err);
        });
    },
    setAllExpParticularDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_EXP_PARTICULAR_DD_LIST", []);
      await NodeLockPannelService.expenseHeadItem(payload)
        .then(async (response) => {
          if (response.status == 200 && response.data && response.data.data) {
            await commit("SET_ALL_EXP_PARTICULAR_DD_LIST", response.data.data);
          } else {
            // console.log(response.data);
          }
        })
        .catch((err) => {
          console.log("Error in getting expenseHeadItem ", err);
        });
    },

    setAllSlineAccDDList: async ({ dispatch, commit, state }, payload) => {
      await commit("SET_ALL_SLINE_ACC_DD_LIST", []);
      NodeLockPannelService.getAllPaymentAccountList(payload)
        .then(async (response) => {
          if (response.status == 200 && response.data && response.data.data) {
            await commit("SET_ALL_SLINE_ACC_DD_LIST", response.data.data);
          } else {
            // console.log(response.data);
          }
          // console.log("AllSlineAccDDList", response);
        })
        .catch((err) => {
          console.log("Error in getting AllSlineAccDDList ", err);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/module/commonDropdownMaster.js